import React, { useEffect, useState } from 'react';
import { AllocationBillableTypeFilter, Checkbox } from '~/components';
import {
  ClientFiltersGroup,
  MemberFiltersGroup,
  ProjectFiltersGroup,
  ResourceFiltersGroup,
} from '~/components/filters';
import FiltersGroup from '~/components/filters/FiltersGroup';
import FiltersDrawer from '../../components/FiltersDrawer';

export default function Filters({ values, isOpen, onClose, onApply }) {
  const [filters, setFilters] = useState(values);

  const handleApply = () => {
    onApply(filters);
  };

  const handleFilter = (filter) => {
    setFilters({ ...filters, ...filter });
  };

  const handleCancel = () => {
    setFilters(values);
    onClose();
  };

  useEffect(() => {
    setFilters(values);
  }, [values]);

  return (
    <FiltersDrawer isOpen={isOpen} onApply={handleApply} onClose={handleCancel}>
      <Checkbox
        checked={filters.onlyAllocatedResources}
        label="Only show resources with allocations"
        onChange={({ target: { checked } }) => handleFilter({ onlyAllocatedResources: checked })}
      />

      <ClientFiltersGroup filters={filters} onChange={handleFilter} />

      <ProjectFiltersGroup filters={filters} onChange={handleFilter} />

      <MemberFiltersGroup filters={filters} onChange={handleFilter} />

      <ResourceFiltersGroup filters={filters} onChange={handleFilter} />

      <FiltersGroup label="Allocation Filters" filters={[filters.allocationBillableTypes]}>
        <AllocationBillableTypeFilter
          value={filters.allocationBillableTypes}
          onChange={({ target: { value } }) => handleFilter({ allocationBillableTypes: value })}
        />
      </FiltersGroup>
    </FiltersDrawer>
  );
}
